import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { EnaioLearnService } from '../../services/enaio-learn.service';
import { JobDescription } from '../../shared/job-description.entity';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';

@Component({
    selector: 'app-edit-job-descriptions',
    templateUrl: './edit-job-descriptions.component.html',
    styleUrls: ['./edit-job-descriptions.component.scss']
})
export class EditJobDescriptionsComponent extends ComponentView {

    service = inject(EnaioLearnService);

    listData: JobDescription[];
    table: TableData;

    async initParams(): Promise<boolean> {
        [this.listData, this.table] = await this.service.adminInitList<JobDescription>(JobDescription, "lea.jobDescription", "job-descriptions", "job-description", "api/lrn/jobdescription", this, [
            new TableColumn("number", null, TableCellType.text, { autoWidth: 3 }), 
            new TableColumn("name", null, TableCellType.text, { autoWidth: 50 }), 
            new TableColumn("group", null, TableCellType.text, { autoWidth: 50 })
        ], [new TableSortColumn("number")], o => new TableRow("", o, { number: o.number, name: o.name, group: o.group }));
        return true;
    }
}
